import SherlockAcConstant from "@/mixins/sherlock/const/sherlockAcConstant.js";
import api from "@/utils/api";

/**
 * NZSC-2859: 자산원클릭 법인명 자동완성 (bizno 프록시) Vuex 모듈.
 *
 * 주의 — apiWrapper(callPostApi) 쓰지 않는 이유:
 * api-public SherlockCorpController 가 `res.status(200).send(result)` 로 응답 envelope
 * 없이 바로 DTO를 반환한다. apiWrapper 는 `res.data.code === 0` 검증을 하므로
 * 이 엔드포인트에선 항상 null 이 된다. axios 인스턴스(api) 를 직접 호출해서
 * { items, totalCount, errorType, ... } 구조를 그대로 받는다.
 *
 * 에러는 throw 하지 않고 `errorType` 필드로 전파된다. 호출부가 분기해야 함.
 */
export const state = {};
export const mutations = {};
export const getters = {};

export const actions = {
  /**************************************************************
   * 법인명 자동완성 검색
   * keyword: string (1~50자)
   * page?: number (기본 1)
   * pagecnt?: number (기본 10, 최대 20)
   **************************************************************/
  async acPostSherlockCorpNameSearch(
    // eslint-disable-next-line no-unused-vars
    { commit },
    { keyword, page = 1, pagecnt = 10 },
  ) {
    try {
      const res = await api.post(SherlockAcConstant.POST_SHERLOCK_CORP_NAME_SEARCH, {
        keyword,
        page,
        pagecnt,
      });
      // api-public 이 200 + { items, totalCount, errorType? } 를 그대로 반환.
      return res?.data ?? null;
    } catch (error) {
      // 네트워크 레벨 실패는 errorType 으로 정규화해서 상위 분기 로직 재사용.
      console.warn("[acPostSherlockCorpNameSearch] network error", error?.message);
      return {
        items: [],
        totalCount: 0,
        errorType: "NETWORK_ERROR",
        message: error?.message || "network error",
      };
    }
  },

  /**************************************************************
   * 법인등록번호 역조회
   * cno: string (숫자+하이픈)
   **************************************************************/
  async acPostSherlockCorpRegnoLookup(
    // eslint-disable-next-line no-unused-vars
    { commit },
    { cno },
  ) {
    try {
      const res = await api.post(SherlockAcConstant.POST_SHERLOCK_CORP_REGNO_LOOKUP, { cno });
      return res?.data ?? null;
    } catch (error) {
      console.warn("[acPostSherlockCorpRegnoLookup] network error", error?.message);
      return {
        item: null,
        errorType: "NETWORK_ERROR",
        message: error?.message || "network error",
      };
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
